export default "__VITE_ASSET__yvVEtlOH__"